import 'react';
import {IconButton, Tooltip} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import type {AdjustmentDetail} from '@/services/auditService/interface/wp-row';
import type {LoanFieldAdjustTarget} from '@/pages/components/audit/adjustment/adjust/dialogs/loan/LoanFieldAdjustPanel';

export type LoanFieldAdjustButtonProps = {
    /** fromPaper FS code for WP→WP (e.g. BS-CL-BLS / PL-FC-LI) */
    fromCode: string;
    /** commonRow.item — Bank name (BankLoan) or MV (VehicleLoan) */
    itemName: string;
    /** Column label of the clicked cell (Current / Interest / …) */
    fieldLabel?: string;
    /** Initial perClient = FS node Client (openingAmount) for the column code */
    perClient: number;
    /** Existing WP→WP adjustments for this field (currAdj / nonCurrAdj / inAdj) */
    existingAdjustments?: AdjustmentDetail[] | null;
    statement?: 'BS' | 'PL';
    disabled?: boolean;
    /** Activate inline panel above SME-FRS (parent owns rendering) */
    onActivate: (target: LoanFieldAdjustTarget) => void;
};

/**
 * Icon beside loan Current / Non-current / Interest cells.
 * Notifies parent to render LoanFieldAdjustPanel above HKFRS SME-FRS.
 */
export default function LoanFieldAdjustButton({
    fromCode,
    itemName,
    fieldLabel,
    perClient,
    existingAdjustments,
    statement,
    disabled,
    onActivate,
}: LoanFieldAdjustButtonProps) {
    return (
        <Tooltip title={`Adjustment (${fieldLabel || itemName})`} arrow>
            <span>
                <IconButton
                    size="small"
                    color="primary"
                    disabled={disabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onActivate({
                            fromCode,
                            itemName,
                            fieldLabel,
                            perClient,
                            existingAdjustments,
                            statement,
                        });
                    }}
                    aria-label={`Adjust ${itemName}`}
                >
                    <SwapHorizIcon fontSize="small"/>
                </IconButton>
            </span>
        </Tooltip>
    );
}
